import * as React from "react";
import Hero from "./components/Hero";
import InnerPage from "../Core/components/InnerPage";
import { PrimaryAlternateLink } from "../Core/components/Buttons";
import { css } from "@emotion/core";
import padding from "../Styles/padding";
import colors from "../Styles/colors";
import { borderButton, ctaButton } from "../Styles/buttons";
import mq from "../Styles/breakpoints";
import { getWindow } from "../Helpers/browsers";
import { App as Swimlane } from "../VideoRows/App";
import PassportUser from '../User/PassportUser';
import styled from "@emotion/styled";

const passportrows = [['Popular On TPT Passport', 'show/trending/?filter=passport', { view: 'show' }]];

let flexItems = css`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-top: ${padding.large};
`;

let exampleLine = css`
  background-image: url('/content/themes/tpt/dist/images/passport/line.png');
  background-size: 50% 39px;
  background-repeat: no-repeat;
  background-position: 0px 10px;
`;

const LogoList = styled.div` 
      display: flex;
      flex-flow: row wrap;
      align-items: center;
      justify-content: center;
      text-align: center;
      margin-bottom: 1.5em;
        
      & img {
        height: 50px;
        margin: 5px;
      }
    `;

let borderBtn = css`
  ${borderButton()};
  color: #000000 !important;
  margin-right: ${padding.small};
`;

let posters = css`
  display: none;
  
  ${mq.large(`
    margin-top: ${padding.xlarge};
    margin-bottom: ${padding.xlarge};
    display: grid;
    display: ms-grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: auto auto auto 1fr;
  `)}
  
  ${mq.xlarge(`
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-template-rows: auto auto 1fr;
  `)}
`;

let colorblock = css`
  width: 100%;
  padding: ${padding.xlarge};
  background-color: #f2f2f2;
  margin: 1.8rem 0;
`;

let padAndCenter = css`
  padding: 1em 2em;
  text-align: center;
  
  ${mq.large(`
    padding: 4em 2em;
  `)}
`;

let isMobile, isSignedIn, passportActive = false;
let user;
getWindow().then(window => {
  isMobile = window.outerWidth < 640;
  user = PassportUser();
  isSignedIn = user.isSignedIn();
  passportActive = user.getPassportStatus() === 'ACTIVE';
});

function App() {
  return (
    <React.Fragment>
      <Hero />
      <InnerPage>
        <div className="row">
          <div css={flexItems} className="small-12 large-6 columns" >
            <div>
              <h2>More quality PBS & TPT Programming</h2>
              <p>TPT Passport is a benefit for qualified TPT members (<a href="https://e.tpt.org/page/61838/donate/1?supporter.appealCode=AMW230901PP2G">$5+ monthly or $60 annually</a>) that unlocks all the shows streaming on the PBS Video App and on our website. With Passport you can watch your favorites like <i>Masterpiece</i>, <i>Finding Your Roots</i>, <i>Nova</i>, <i>Nature</i>, <i>Frontline</i>, <i>America’s Test Kitchen</i> and many more, on-demand anytime, anywhere. </p>
              <div css={css`margin-bottom:${padding.large};`}>
                {!isSignedIn && <a href="/sign-in" css={borderBtn} >Sign in</a>}
                {!passportActive && <a href="https://e.tpt.org/page/61838/donate/1?supporter.appealCode=AMW230901PP2G" target="_blank" css={ctaButton} >Get TPT Passport</a>}
                {passportActive && <p><strong>Our records indicate you have an active passport account.</strong></p>}
              </div>
            </div>
            <div>
              <p>Technical Problems? <a target="_blank" href="http://help.pbs.org/support/tickets/new">Submit a help ticket</a> or call <a href="tel:1-844-454-8057" css={css`white-space:nowrap;`}>1-844-454-8057</a></p>
              <p>Have Questions? <a target="_blank" href="https://help.pbs.org/support/solutions/5000121793">TPT Passport FAQs</a></p>
            </div>
          </div>
          <div className="small-12 large-6 show-for-large-up columns">
            <div css={css`width:100%;`}>
              <div css={posters}>
                <img src="/content/themes/tpt/dist/images/passport/01.jpg" alt="American Experience" />
                <img src="/content/themes/tpt/dist/images/passport/03.jpg" alt="Nature" />
                <img src="/content/themes/tpt/dist/images/passport/05.jpg" alt="Great British Baking Show" />
                <img src="/content/themes/tpt/dist/images/passport/06.jpg" alt="Nova" />
                <img src="/content/themes/tpt/dist/images/passport/07.jpg" alt="Victoria" />
                <img className="show-for-large-down" src="/content/themes/tpt/dist/images/passport/08.jpg" alt="Grand Performances" />
                <img src="/content/themes/tpt/dist/images/passport/10.jpg" alt="Antiques Roadshow" />
                <img src="/content/themes/tpt/dist/images/passport/11.jpg" alt="Poldark" />
                <img src="/content/themes/tpt/dist/images/passport/12.jpg" alt="Austin City Limits" />
              </div>
            </div>
            <div css={css`width:100%; text-align:center; margin-bottom:${padding.xlarge};`} >
              <a href="/passport/shows/">Browse Shows</a>
            </div>
          </div>
        </div>
      </InnerPage>
      {isMobile &&
        <div css={css`background-color: ${colors.coreColor1};margin-top: ${padding.xlarge};`}>
          <Swimlane mobileView={isMobile} rows={passportrows} />
          <div css={css`display:flex;justify-content:center;align-items:center;padding-bottom: ${padding.xlarge};`}><PrimaryAlternateLink href="/shows-a-z">Browse Shows</PrimaryAlternateLink></div>
        </div>
      }
      <div css={colorblock}>
        <InnerPage>
          <div className="row">
            <div css={[flexItems, { justifyContent: 'flex-start' }]} className="small-12 large-6 columns" >
              <h2>Look for this symbol</h2>
              <img css={css`margin-bottom:${padding.large};width:100%;`} src="/content/themes/tpt/dist/images/passport/example-vert.png" className="show-for-medium-down" alt="passport icon example" />
              <p>TPT Passport content is identified by this distinctive icon.</p>
            </div>
            <div css={[flexItems, exampleLine, { justifyContent: 'flex-start', alignItems: 'center' }]} className="small-12 large-6 columns" >
              <img css={css`max-width:300px;margin-bottom:${padding.standard}`} src="/content/themes/tpt/dist/images/passport/passport-icon-image.jpg" className="show-for-large-up" alt="passport icon example" />
            </div>
          </div>
        </InnerPage>
      </div>
      <div className="row">
        <div css={padAndCenter} className="large-6 columns">
          <img alt="PBS application featured on several mobile devices" src="/content/themes/tpt/dist/images/passport/tv.png" />
          <h2>Watch on your big screen</h2>
          <p>TPT Passport is available on most popular streaming devices in the PBS app.</p>
          <LogoList>
            <a target="_blank" href="https://itunes.apple.com/us/app/pbs-video/id398349296">
              <img src="/content/themes/tpt/dist/images/passport/apple-tv.jpg" alt="Apple TV logo" />
            </a>
            <a target="_blank" href="https://www.amazon.com/Public-Broadcasting-Service-PBS-Video/dp/B008Z2NVGK">
              <img src="/content/themes/tpt/dist/images/passport/fire-tv.jpg" alt="Fire TV logo" />
            </a>
            <a target="_blank" href="https://help.pbs.org/support/solutions/12000002760">
              <img src="/content/themes/tpt/dist/images/passport/chromecast.jpg" alt="Chromecast logo" />
            </a>
            <a target="_blank" href="https://channelstore.roku.com/details/23353/pbs">
              <img src="/content/themes/tpt/dist/images/passport/roku.jpg" alt="Roku logo" />
            </a>
            <a target="_blank" href="https://help.pbs.org/support/solutions/articles/5000692515-can-i-access-passport-content-on-all-devices-and-platforms-">
              <img src="/content/themes/tpt/dist/images/passport/samsungtv.jpg" alt="Samsung SmartTV" />
            </a>
          </LogoList>
        </div>
        <div css={padAndCenter} className="large-6 columns">
          <img alt="PBS application featured on several mobile devices" src="/content/themes/tpt/dist/images/passport/pbs-mobile-app.png" />
          <h2>Watch on your mobile devices</h2>
          <p>Download the PBS App on your phone or tablet and start streaming today!</p>
          <LogoList>
            <a target="_blank" href="https://itunes.apple.com/us/app/pbs-video/id398349296">
              <img src="/content/themes/tpt/dist/images/passport/mobile-apple.jpg" alt="Download from Apple App Store logo" />
            </a>
            <a target="_blank" href="https://play.google.com/store/apps/details?id=com.pbs.video">
              <img src="/content/themes/tpt/dist/images/passport/mobile-android.jpg" alt="Get it on Google Play logo" />
            </a>
          </LogoList>
        </div>
      </div>
      <div className="row" css={css`margin-bottom:60px;`}>
        <div className="small-12 columns text-center">
          <a href="https://e.tpt.org/page/61838/donate/1?supporter.appealCode=AMW230901PP2G" css={ctaButton} >Get TPT Passport</a>
        </div>
      </div>

      {!isMobile &&
        <div css={css`background-color: ${colors.coreColor1};margin-top: ${padding.xxlarge};margin-bottom: ${padding.xxlarge};padding-top: 40px;padding-bottom: 40px;`}>
          <Swimlane mobileView={isMobile} rows={passportrows} />
        </div>
      }
      <div css={css`display: flex;flex-direction: column;justify-content:center;align-items:center;padding: 40px 0;`}>
        <h2>Any Questions?</h2>
        <p>Visit the <a href="https://help.pbs.org/support/solutions/5000121793">TPT Passport FAQs</a> page.</p>
      </div>
    </React.Fragment>
  );
}

export default App;